import * as React from 'react';
import { BasePureComponent } from '../BaseComponent';
import * as Data from '../../Data';
import * as Dati from '../../Dati';
import * as Glob from '../../Globale';
import { BottoneAPI, Trad } from '../../components/';

interface IAddendumListModalProps {
    Data: Dati.CAppendiceTestata;
    OnStatusChange: any;
}

export class AddendumListModal extends BasePureComponent<IAddendumListModalProps> {
    public constructor(props: any) {
        super(props);

        this.OnStatusChange = this.OnStatusChange.bind(this);
    }

    private OnStatusChange(sender: BottoneAPI, data: Dati.CRisAPI) {
        if (data.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), data.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad('Endorsement system').toUpperCase(), Trad.Trad("The status is changed successfully"));
            this.props.OnStatusChange();
        }
    }

    public render() {
        const data = this.props.Data;
        const id = data.ID_Appendice;

        return (
            <div className="modal fade" id={`kt_modal_${id}`} role="dialog" aria-labelledby="modalCartaServizi">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header alert-info">
                            <h5 className="modal-title" id="addendumModalLongTitle">{Trad.Trad("Endorsement system")}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body col-lg-12">
                            <div className="form-group kt-form login-form__group row">
                                <div className="col-lg-8 kt-form login-form__group-sub">
                                    <label className="form-control-label">{Trad.Trad("Addendum type")}</label>
                                    <input className="form-control kt-input" type="text" value={data.ID_TipoAppendice && Trad.Trad(data.ID_TipoAppendice)} name="ID_TipoAppendice" readOnly />
                                </div>
                            </div>
                            <div className="form-group kt-form login-form__group row">
                                <div className={Glob.DimensioneCSS(6)}>
                                    <label className="form-control-label">{Trad.Trad("DataEffetto")}</label>
                                    <input className="form-control kt-input" type="text" value={data.DataEffetto && Data.DataValore(data.DataEffetto)} name="DataEffetto" readOnly />
                                </div>
                                <div className={Glob.DimensioneCSS(6)}>
                                    <label className="form-control-label">{Trad.Trad("DataScadenza")}</label>
                                    <input className="form-control kt-input" type="text" value={data.DataScadenza && Data.DataValore(data.DataScadenza)} name="DataScadenza" readOnly />
                                </div>
                            </div>
                            <div className="form-group kt-form login-form__group row" key="Nota">
                                <div className="col-lg-12">
                                    <label>{Trad.Trad("Note")}</label>
                                    <div className="kt-input-icon kt-input-icon--right">
                                        <textarea
                                            className="form-control"
                                            value={data.Nota}
                                            name="Nota"
                                            id="Nota"                                            
                                            rows={3}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">{Trad.Trad("Chiudi")}</button>
                            <BottoneAPI
                                Default={false}
                                URL={`/api/Appendice/ChangeStatus?id_Appendice=${id}&id_TipoAppendiceStato=${Glob.Tipi_APS_Emessa}`}
                                Metodo="POST"
                                OnErrore={this.OnErrore}
                                ClasseAttivo="btn btn-success kt-btn kt-btn--icon"
                                Testo={Trad.Trad("Approva")}
                                DataDismiss="modal"
                                OnClick={this.OnStatusChange}
                            />
                            <BottoneAPI
                                Default={false}
                                URL={`/api/Appendice/ChangeStatus?id_Appendice=${id}&id_TipoAppendiceStato=${Glob.Tipi_APS_Rifiutata}`}
                                Metodo="POST"
                                OnErrore={this.OnErrore}
                                ClasseAttivo="btn btn-danger kt-btn kt-btn--icon"
                                Testo={Trad.Trad("Rifiuta")}
                                DataDismiss="modal"
                                OnClick={this.OnStatusChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AddendumList/AddendumListModal.tsx